(function () {
  var garageSelector = '.partfinder-garage';
  var rootUrl = 'https://car.govedia.com';
  var mmyCookieName = 'gv_mmy';
  var vehicleCookieName = 'gv_vehicle_json';
  var isRendering = false;
  var suppressObserver = false;

  function getGarage() {
    return document.querySelector(garageSelector);
  }

  function getLabel(id, fallback) {
    var element = document.getElementById(id);
    return element ? element.textContent.trim() : fallback;
  }

  function readCookie(name) {
    var nameEq = encodeURIComponent(name) + '=';
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i += 1) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(nameEq) !== 0) continue;

      try {
        return JSON.parse(decodeURIComponent(cookie.substring(nameEq.length)));
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function uid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (token) {
      var rand = (Math.random() * 16) | 0;
      var value = token === 'x' ? rand : (rand & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function getCustomerId() {
    if (window.MMY_Customer) return window.MMY_Customer;

    var cookie = readCookie(mmyCookieName);
    if (cookie && cookie.customer) return cookie.customer;

    return uid();
  }

  function writeMmyCookie(name, value) {
    var existing = readCookie(mmyCookieName) || readCookie(vehicleCookieName);
    var customer = window.MMY_Customer || (existing && existing.customer) || uid();
    var payload = { customer: customer, mmy: value };
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(JSON.stringify(payload)) + '; path=/';
  }

  function getCurrentVehicle() {
    var cookie = readCookie(vehicleCookieName);
    var vehicle = cookie && cookie.mmy;

    if (!vehicle || typeof vehicle !== 'object') return null;
    if (!vehicle.make || !vehicle.model || !vehicle.year) return null;

    return vehicle;
  }

  function parseVehicle(value) {
    if (!value) return null;
    if (typeof value === 'object' && !Array.isArray(value)) return value;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function parseVehicles(value) {
    var vehicles = [];

    if (!value) return vehicles;

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        var vehicle = parseVehicle(item);
        if (vehicle) vehicles.push(vehicle);
      });
      return vehicles;
    }

    if (typeof value === 'object' && value.vehicles) {
      return parseVehicles(value.vehicles);
    }

    if (typeof value !== 'string') return vehicles;

    var trimmed = value.trim();
    if (!trimmed) return vehicles;

    try {
      var parsed = JSON.parse(trimmed);
      return parseVehicles(parsed);
    } catch (error) {
      try {
        return parseVehicles(JSON.parse('[' + trimmed + ']'));
      } catch (nestedError) {
        return vehicles;
      }
    }
  }

  function cleanPart(value) {
    return String(value || '')
      .replace(/-fs-/g, '/')
      .trim();
  }

  function hasSubmodel(vehicle) {
    var submodel = cleanPart(vehicle && vehicle.submodel);
    return submodel && submodel !== '~';
  }

  function vehicleKey(vehicle) {
    if (!vehicle) return '';

    return [vehicle.year, vehicle.make, vehicle.model, hasSubmodel(vehicle) ? vehicle.submodel : '']
      .map(cleanPart)
      .join('|')
      .toLowerCase();
  }

  function uniqueVehicles(vehicles) {
    var seen = {};
    var unique = [];

    vehicles.forEach(function (vehicle) {
      var key = vehicleKey(vehicle);
      if (!key || seen[key]) return;
      seen[key] = true;
      unique.push(vehicle);
    });

    return unique;
  }

  function vehicleDisplay(vehicle) {
    var parts = [vehicle.year, vehicle.make, vehicle.model];
    if (hasSubmodel(vehicle)) parts.push(vehicle.submodel);
    return parts.map(cleanPart).filter(Boolean).join(' ');
  }

  function encodeTag(value) {
    return String(value || '')
      .replace(/-fs-/g, '-')
      .replace(/\//g, '-')
      .replace(/\s+/g, '-')
      .replace(/[&.,]/g, '-')
      .replace(/"/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function vehicleTag(vehicle) {
    var parts = [vehicle.make, vehicle.model];
    if (hasSubmodel(vehicle)) parts.push(vehicle.submodel);
    parts.push(vehicle.year);
    return encodeTag(parts.map(cleanPart).filter(Boolean).join(' '));
  }

  function getVehicleFromElement(element) {
    return parseVehicle(element && element.getAttribute('json'));
  }

  function getDisplayedVehicles() {
    var links = document.querySelectorAll(garageSelector + ' .vehicle-link[json]');
    var vehicles = [];

    links.forEach(function (link) {
      var vehicle = getVehicleFromElement(link);
      if (vehicle) vehicles.push(vehicle);
    });

    return uniqueVehicles(vehicles);
  }

  function createVehicleItem(vehicle) {
    var tag = vehicleTag(vehicle);
    var json = JSON.stringify(vehicle);
    var li = document.createElement('li');
    var vehicleLink = document.createElement('a');
    var actions = document.createElement('div');
    var shopLink = document.createElement('a');
    var deleteLink = document.createElement('a');

    li.id = tag;
    li.setAttribute('data-partfinder-vehicle-key', vehicleKey(vehicle));

    vehicleLink.href = 'javascript:void(0);';
    vehicleLink.className = 'vehicle-link';
    vehicleLink.setAttribute('json', json);
    vehicleLink.setAttribute('ref', tag);
    vehicleLink.textContent = vehicleDisplay(vehicle);

    actions.className = 'partfinder-garage__vehicle-actions';

    shopLink.href = '/collections/all/' + tag;
    shopLink.className = 'gv-shop-vehicle';
    shopLink.setAttribute('json', json);
    shopLink.setAttribute('ref', tag);
    shopLink.textContent = getLabel('partfinder-shop-vehicle-label', 'Shop');

    deleteLink.href = 'javascript:void(0);';
    deleteLink.className = 'gv-del-vehicle';
    deleteLink.setAttribute('json', json);
    deleteLink.setAttribute('ref', tag);
    deleteLink.textContent = getLabel('gv-delete-vehicle-label', 'Remove');

    actions.appendChild(shopLink);
    actions.appendChild(deleteLink);

    li.appendChild(vehicleLink);
    li.appendChild(actions);

    return li;
  }

  function ensureVehicleShell() {
    var garage = getGarage();
    if (!garage) return null;

    var vehicles = garage.querySelector('.gv-vehicles');
    if (!vehicles) return null;

    var list = vehicles.querySelector('ul');
    if (!list) {
      if (!vehicles.querySelector('.add-vehicle')) return null;

      var popup = vehicles.querySelector('.popup') || vehicles;
      list = document.createElement('ul');
      popup.insertBefore(list, popup.querySelector('.add-vehicle'));
    }

    list.id = 'root-vehicle-list';
    return list;
  }

  function renderVehicles(vehicles) {
    var list = ensureVehicleShell();
    if (!list) return;

    var unique = uniqueVehicles(vehicles);

    isRendering = true;
    suppressObserver = true;
    list.innerHTML = '';

    unique.forEach(function (vehicle) {
      list.appendChild(createVehicleItem(vehicle));
    });

    list.classList.toggle('vehicles-present', unique.length > 0);
    isRendering = false;
    window.setTimeout(function () {
      suppressObserver = false;
    }, 0);
  }

  function normalizeGarageList() {
    if (isRendering) return;

    var list = ensureVehicleShell();
    if (!list) return;

    var vehicles = [];
    list.querySelectorAll('li').forEach(function (item) {
      var link = item.querySelector('.vehicle-link[json]');
      var vehicle = getVehicleFromElement(link);
      if (vehicle) vehicles.push(vehicle);
    });

    renderVehicles(vehicles);
  }

  function setButtonState(button, label, isDisabled) {
    if (!button) return;

    button.textContent = label;
    button.classList.toggle('is-saving', isDisabled);
    button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
  }

  function flashButton(button, label) {
    var defaultLabel = getLabel('gv-add-vehicle-label', 'Save current vehicle');
    setButtonState(button, label, true);
    window.setTimeout(function () {
      setButtonState(button, defaultLabel, false);
    }, 1400);
  }

  function postToPartFinder(path, data) {
    if (window.jQuery && window.jQuery.ajax) {
      return new Promise(function (resolve, reject) {
        window.jQuery.ajax({
          url: rootUrl + path,
          type: 'POST',
          data: data,
          success: resolve,
          error: function (_xhr, _status, error) {
            reject(new Error(error || 'Request failed'));
          },
        });
      });
    }

    return fetch(rootUrl + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(data).toString(),
    }).then(function (response) {
      if (!response.ok) throw new Error('Request failed');
      return response.json();
    });
  }

  function saveCurrentVehicle(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    var vehicle = getCurrentVehicle();
    if (!vehicle) {
      window.alert(getLabel('gv-select-vehicle-label', 'Select a vehicle before saving it to My Garage.'));
      return;
    }

    var currentVehicles = getDisplayedVehicles();
    var currentKey = vehicleKey(vehicle);
    var alreadySaved = currentVehicles.some(function (savedVehicle) {
      return vehicleKey(savedVehicle) === currentKey;
    });

    if (alreadySaved) {
      flashButton(button, 'Already saved');
      return;
    }

    renderVehicles(currentVehicles.concat([vehicle]));

    var pendingItem = null;
    document.querySelectorAll(garageSelector + ' [data-partfinder-vehicle-key]').forEach(function (item) {
      if (item.getAttribute('data-partfinder-vehicle-key') === currentKey) pendingItem = item;
    });
    if (pendingItem) pendingItem.classList.add('is-pending');

    setButtonState(button, 'Saving...', true);

    postToPartFinder('/Shopify/SaveModel', {
      customerid: getCustomerId(),
      model: JSON.stringify(vehicle),
    })
      .then(function (data) {
        if (data.status === 'error' && data.err !== 'Item already added.') {
          throw new Error(data.err || 'Unable to save vehicle');
        }

        var savedVehicles = parseVehicles(data.vehicles);
        if (!savedVehicles.some(function (savedVehicle) { return vehicleKey(savedVehicle) === currentKey; })) {
          savedVehicles.push(vehicle);
        }

        renderVehicles(savedVehicles);
        flashButton(button, 'Saved');
      })
      .catch(function (error) {
        renderVehicles(currentVehicles);
        setButtonState(button, getLabel('gv-add-vehicle-label', 'Save current vehicle'), false);
        window.alert(error.message || 'Unable to save vehicle');
      });
  }

  function selectVehicle(link) {
    var vehicle = getVehicleFromElement(link);
    if (!vehicle) return;

    var tag = vehicleTag(vehicle);
    writeMmyCookie(vehicleCookieName, vehicle);
    writeMmyCookie(mmyCookieName, tag);

    window.location.href = '/collections/all/' + tag;
  }

  function deleteVehicle(link) {
    var vehicle = getVehicleFromElement(link);
    if (!vehicle) return;

    if (!window.confirm(getLabel('gv-delete-vehicle-confirm-label', 'Remove this vehicle from My Garage?'))) return;

    var item = link.closest('li');
    if (item) item.classList.add('is-removing');

    postToPartFinder('/Shopify/DeleteModel', {
      customerid: getCustomerId(),
      model: JSON.stringify(vehicle),
    })
      .then(function (data) {
        if (data.status === 'error') throw new Error(data.err || 'Unable to remove vehicle');
        renderVehicles(parseVehicles(data.vehicles));
      })
      .catch(function (error) {
        if (item) item.classList.remove('is-removing');
        window.alert(error.message || 'Unable to remove vehicle');
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var saveButton = event.target.closest(garageSelector + ' .add-vehicle');
      var vehicleLink = event.target.closest(garageSelector + ' .vehicle-link');
      var shopLink = event.target.closest(garageSelector + ' .gv-shop-vehicle');
      var deleteLink = event.target.closest(garageSelector + ' .gv-del-vehicle');

      if (!saveButton && !vehicleLink && !shopLink && !deleteLink) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (saveButton) {
        saveCurrentVehicle(saveButton);
      } else if (deleteLink) {
        deleteVehicle(deleteLink);
      } else if (shopLink) {
        selectVehicle(shopLink);
      } else if (vehicleLink) {
        selectVehicle(vehicleLink);
      }
    },
    true
  );

  function observeGarage() {
    var garage = getGarage();
    if (!garage || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (isRendering || suppressObserver) return;
      window.requestAnimationFrame(normalizeGarageList);
    });

    observer.observe(garage, { childList: true, subtree: true });
    normalizeGarageList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGarage);
  } else {
    observeGarage();
  }
})();
